<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="d-flex with-media">
          <div class="p-2 w-70">
            <div class="media">
              <img src="/static/img/user@3x.png" class="avatar" />
              <div class="media-body">
                <h5>{{examInfo.class_user_name}}  <span class="badge rose align-middle">{{examInfo.cate_path}}</span></h5>
                <p><span class="gray">클래스</span> <strong>{{examInfo.class_name}}</strong></p>
              </div>
            </div>
          </div>
          <div class="p-2 ml-auto button-group">
            <button type="button" class="btn btn-secondary" @click="handleCommand('download')">PDF 저장</button>
            <button type="button" class="btn mint" @click="handleCommand('send')">알림톡 전송</button>
          </div>
        </div>
      </div>
    </div>

    <el-tabs ref="gradeTab" v-model="activeTabName" @tab-click="handlerTabClick">
      <el-tab-pane name="tab-personal">
        <span slot="label" class="gray label">개인 성적표</span>

        <div class="grade-personal">
          <div class="card second-card">
            <div class="card-body">
              <div class="d-flex">
                <div class="p-2">
                  <h2>개인 성적표</h2>
                </div>
                <div class="p-2 ml-auto">
                </div>
              </div>
              <div class="d-flex blue-gray">
                <div class="p-2">
                  <h1 class="title">{{examInfo.exam_title}}</h1>
                  <p>
                    <span class="gray">시험유형</span> {{examInfo.exam_paper_type_name}}
                    <span class="gray"> · 시험일자</span> {{examInfo.open_dt}}
                    <span class="gray"> · 클래스</span> <strong>{{examInfo.class_name}}</strong>
                    <template v-if="examInfo.curriculum_yn === 'Y'">
                      <span class="gray"> · 커리큘럼</span> {{examInfo.curriculum_name}}
                      <span class="gray"> · 회차</span> {{examInfo.times}}회차
                    </template>
                  </p>
                </div>
                <div class="p-2 ml-auto">
                  <span class="number"><strong>{{examInfo.exam_rank}}</strong> / {{examInfo.entry_cnt}}</span><br/>
                  석차
                </div>
              </div>

              <el-row :gutter="40">
                <el-col :span="12">
                  <fieldset>
                    <div class="d-flex">
                      <div class="p-2">
                        <h2>성적 분석</h2>
                      </div>
                      <div class="p-2">
                        <strong><span class="number mint"></span></strong>
                      </div>
                    </div>
                    <data-tables ref="tabGroupTable" :data="groupData" :table-props="tableProps" :pagination-props="emptyPaginationProps" :page-size="emptyPageSize" v-loading="searchLoading">
                      <el-table-column v-for="(column, index) in groupColumns" :key="'row_' + index" header-align="center"
                        :prop="column.prop" :label="column.label" :align="column.align" :min-width="column.width" :label-class-name="'stone-table-label '" :class-name="'stone-table-cell ' + column.class" :formatter="column.formatter">
                        <template slot-scope="scope">
                          <span class="number">{{ scope.row[column.prop] }}</span><br />
                          <span class="number" v-if="column.prop !== 'cate_code_name'">{{ `(${scope.row[column.prop + '_100']})` }}</span>
                        </template>
                      </el-table-column>
                    </data-tables>
                    <!-- <stone-data-table
                      ref="tabGroupTable"
                      :loading="searchLoading"
                      :columns="groupColumns"
                      :data="groupData"
                      :table-props="tableProps"
                      :page-size="emptyPageSize"
                      :pagination-props="emptyPaginationProps">
                    </stone-data-table> -->
                  </fieldset>
                </el-col>
                <el-col :span="12">
                  <fieldset>
                    <div class="d-flex">
                      <div class="p-2">
                        <h2>영역별 성적 비교</h2>
                      </div>
                      <div class="p-2 ml-auto">
                      <img src="/static/img/mint-circle.svg" /> 내점수 <img src="/static/img/navy-circle.svg" /> 평균점수
                      </div>
                    </div>
                    <bar-chart :chart-data="barChartData" :height="barChartHeight" :options="barChartOptions" :styles="barChartStyles"></bar-chart>
                  </fieldset>
                </el-col>
              </el-row>

              <template v-if="graphVisible">
                <el-row :gutter="40">
                  <el-col :span="12">
                    <fieldset v-if="lineVisible">
                      <div class="d-flex">
                        <div class="p-2">
                          <h2>성적 변화 그래프</h2>
                        </div>
                        <div class="p-2 ml-auto">
                        <img src="/static/img/mint-circle.svg" /> 내점수 <img src="/static/img/navy-circle.svg" /> 평균점수
                        </div>
                      </div>
                      <line-chart ref="lineChart1" :chart-data="lineChartData" :height="lineChartHeight" :options="lineChartOptions" :styles="lineChartStyles"></line-chart>
                    </fieldset>
                    <fieldset v-if="radarVisible">
                      <div class="d-flex">
                        <div class="p-2">
                          <!-- <h2>영역별 누적 분석</h2> -->
                        </div>
                        <div class="p-2 ml-auto">
                        <img src="/static/img/mint-circle.svg" /> 내점수 <img src="/static/img/navy-circle.svg" /> 평균점수
                        </div>
                      </div>
                      <radar-chart :chart-data="radarChartData" :height="radarChartHeight" :options="radarChartOptions" :styles="radarChartStyles"></radar-chart>
                    </fieldset>
                  </el-col>
                  <el-col :span="12">
                    <fieldset>
                      <div class="d-flex">
                        <div class="p-2">
                          <h2>취약유형 분석</h2>
                        </div>
                        <div class="p-2">
                          <strong><span class="number mint"></span></strong>
                        </div>
                      </div>
                      <stone-data-table
                        :loading="searchLoading"
                        :columns="groupWrongColumns"
                        :data="quizWrongData"
                        :table-props="quizTableProps"
                        :page-size="emptyPageSize"
                        :pagination-props="emptyPaginationProps">
                      </stone-data-table>
                    </fieldset>
                  </el-col>
                </el-row>
              </template>
              <template v-else>
                <fieldset>
                  <div class="d-flex">
                    <div class="p-2">
                      <h2>취약유형 분석</h2>
                    </div>
                    <div class="p-2">
                      <strong><span class="number mint"></span></strong>
                    </div>
                  </div>
                  <stone-data-table
                    :loading="searchLoading"
                    :columns="groupWrongColumns"
                    :data="quizWrongData"
                    :table-props="quizTableProps"
                    :page-size="emptyPageSize"
                    :pagination-props="emptyPaginationProps">
                  </stone-data-table>
                </fieldset>
              </template>

              <fieldset>
                <div class="d-flex">
                  <div class="p-2">
                    <h2>문항 분석</h2>
                  </div>
                  <div class="p-2">
                    <strong><span class="number mint"></span></strong>
                  </div>
                </div>
                <div class="el-table el-table--fit el-table--border el-table--enable-row-hover el-table--enable-row-transition">
                  <table cellspacing="0" cellpadding="0" border="0" class="el-table__header" width="100%">
                    <template v-for="t in quizSplitCount">
                        <thead :key="'th_1_' + t" class="has-gutter">
                        <tr :key="'tr_1_' + t" :with="trIdx = (t - 1) * itemCount">
                          <th class="is-center stone-table-cell stone-table-label">문항</th>
                          <th v-for="i in itemCount" :key="'td_1_' + (t * i)" :with="idx = i + trIdx - 1" class="is-center stone-table-cell stone-table-label">
                            <span class="number" v-if="quizData[idx]">{{quizData[idx].display_no}}</span>
                          </th>
                        </tr>
                        </thead>
                        <tr :key="'tr_2_' + t">
                          <th class="is-center stone-table-cell stone-table-label">채점표</th>
                          <td v-for="i in itemCount" :key="'td_2_' + (t * i)" :with="idx = i + trIdx - 1" class="is-center stone-table-cell">
                            <span v-if="quizData[idx]" :class="getSolutionClassName(quizData[idx].solution_yn)">{{getSolutionName(quizData[idx].solution_yn)}}</span>
                          </td>
                        </tr>
                        <tr :key="'tr_3_' + t">
                          <th class="is-center stone-table-cell stone-table-label">정답률</th>
                          <td v-for="i in itemCount" :key="'td_3_' + (t * i)" :with="idx = i + trIdx - 1" class="is-center stone-table-cell">
                            <span v-if="quizData[idx]" :class="getSolutionRateClassName(quizData[idx].solution_yn)">{{formatterPrecision(quizData[idx].solution_rate)}}</span>
                          </td>
                        </tr>
                        <tr :key="'tr_4_' + t">
                          <th class="is-center stone-table-cell stone-table-label">영역</th>
                          <td v-for="i in itemCount" :key="'td_4_' + (t * i)" :with="idx = i + trIdx - 1" class="is-center stone-table-cell">
                            <span v-if="quizData[idx]" :class="getSolutionRateClassName(quizData[idx].solution_yn)">{{quizData[idx].group_cate_code_name}}</span>
                          </td>
                        </tr>
                    </template>
                  </table>
                </div>
              </fieldset>

              <fieldset>
                <h2>선생님 의견</h2>
                <el-input type="textarea" :rows="5" v-model.trim="examInfo.exam_comment" placeholder="코멘트를 입력하십시오."></el-input>
                <div class="text-right mt-2">
                  <button class="btn mint" type="primary" v-show="commentVisible" @click="saveComment(1)">저장</button>
                </div>
              </fieldset>
            </div>
          </div>
        </div>

      </el-tab-pane>
      <!-- 1회차 이상인 경우에는 종합 성적표 탭을 보여준다. -->
      <el-tab-pane name="tab-total" v-if="examInfo.curriculum_yn === 'Y' && examInfo.times > 0">
        <span slot="label" class="gray label">종합 성적표</span>

        <div class="grade-total">
          <div class="card second-card">
            <div class="card-body">
              <div class="d-flex">
                <div class="p-2">
                  <h2>종합 성적표</h2>
                </div>
                <div class="p-2 ml-auto">
                </div>
              </div>

              <div class="d-flex blue-gray">
                <div class="p-2">
                  <h1 class="title">{{examInfo.book_name}}</h1>
                  <p>
                    <!-- <span class="gray">커리큘럼</span> {{examInfo.curriculum_name}}
                    <span class="gray"> · 회차</span> {{examInfo.times}}회차 -->
                  </p>
                </div>
              </div>

              <el-row :gutter="40">
                <el-col :span="12">
                  <fieldset>
                    <div class="d-flex">
                      <div class="p-2">
                        <h2>성적 분석</h2>
                      </div>
                      <div class="p-2">
                        <strong><span class="number mint"></span></strong>
                      </div>
                    </div>
                    <div class="el-table el-table--fit el-table--border el-table--enable-row-hover el-table--enable-row-transition user-table-times">
                      <table cellspacing="0" cellpadding="0" border="0" class="el-table__header" width="100%">
                        <template v-for="t in examTotalTimesSplitCount">
                            <thead :key="'th_1_' + t" class="has-gutter">
                            <tr :key="'tr_1_' + t" :with="trIdx = (t - 1) * examTotalTimesCount">
                              <th class="is-center stone-table-cell stone-table-label"></th>
                              <th v-for="i in examTotalTimesCount" :key="'td_1_' + (t * i)" :with="idx = i + trIdx - 1" class="is-center stone-table-cell stone-table-label">
                                <span class="number" v-if="examTotalTimesData[idx]">{{examTotalTimesData[idx].times}}회차</span>
                              </th>
                            </tr>
                            </thead>
                            <tr :key="'tr_2_' + t">
                              <th class="is-center stone-table-cell stone-table-label number">내점수 / 배점<br />(백분위 점수)</th>
                              <td v-for="i in examTotalTimesCount" :key="'td_2_' + (t * i)" :with="idx = i + trIdx - 1" class="is-center stone-table-cell td-times">
                                <div class="number" v-if="examTotalTimesData[idx] && examTotalTimesData[idx].exam_user_stat === 'S'"><strong>{{examTotalTimesData[idx].exam_score}}</strong> / {{examTotalTimesData[idx].quiz_score}}</div>
                                <div class="number" v-if="examTotalTimesData[idx] && examTotalTimesData[idx].exam_user_stat === 'S'">{{`(${examTotalTimesData[idx].exam_score_100})`}}</div>
                              </td>
                            </tr>
                        </template>
                      </table>
                    </div>
                  </fieldset>
                </el-col>
                <el-col :span="12">
                  <fieldset>
                    <div class="d-flex">
                      <div class="p-2">
                        <h2>석차 분석</h2>
                      </div>
                      <div class="p-2">
                        <strong><span class="number mint"></span></strong>
                      </div>
                    </div>
                    <div class="el-table el-table--fit el-table--border el-table--enable-row-hover el-table--enable-row-transition user-table-times">
                      <table cellspacing="0" cellpadding="0" border="0" class="el-table__header" width="100%">
                        <template v-for="t in examTotalTimesSplitCount">
                            <thead :key="'th_1_' + t" class="has-gutter">
                            <tr :key="'tr_1_' + t" :with="trIdx = (t - 1) * examTotalTimesCount">
                              <th class="is-center stone-table-cell stone-table-label"></th>
                              <th v-for="i in examTotalTimesCount" :key="'td_1_' + (t * i)" :with="idx = i + trIdx - 1" class="is-center stone-table-cell stone-table-label">
                                <span class="number" v-if="examTotalTimesData[idx]">{{examTotalTimesData[idx].times}}회차</span>
                              </th>
                            </tr>
                            </thead>
                            <tr :key="'tr_2_' + t">
                              <th class="is-center stone-table-cell stone-table-label number">석차 / 전체</th>
                              <td v-for="i in examTotalTimesCount" :key="'td_2_' + (t * i)" :with="idx = i + trIdx - 1" class="is-center stone-table-cell td-times">
                                <div class="number" v-if="examTotalTimesData[idx] && examTotalTimesData[idx].exam_user_stat === 'S'"><strong>{{examTotalTimesData[idx].exam_rank}}</strong> / {{examTotalTimesData[idx].entry_cnt}}</div>
                              </td>
                            </tr>
                        </template>
                      </table>
                    </div>
                  </fieldset>
                </el-col>
              </el-row>

              <el-row :gutter="40">
                <el-col :span="12">
                  <fieldset>
                    <div class="d-flex">
                      <div class="p-2">
                        <h2>성적 변화 그래프</h2>
                      </div>
                      <div class="p-2 ml-auto">
                      <img src="/static/img/mint-circle.svg" /> 내점수 <img src="/static/img/navy-circle.svg" /> 평균점수
                      </div>
                    </div>
                    <line-chart ref="lineChart2" :chart-data="lineChartData" :height="timesLineChartHeight" :options="lineChartOptions2" :styles="timesLineChartStyles"></line-chart>
                  </fieldset>
                  <fieldset>
                    <div class="d-flex">
                      <div class="p-2">
                        <!-- <h2>영역별 누적 분석</h2> -->
                      </div>
                      <div class="p-2 ml-auto">
                      <img src="/static/img/mint-circle.svg" /> 내점수 <img src="/static/img/navy-circle.svg" /> 평균점수
                      </div>
                    </div>
                    <radar-chart :chart-data="radarTotalChartData" :height="timesRadarChartHeight" :options="radarChartOptions" :styles="timesRadarChartStyles"></radar-chart>
                  </fieldset>
                </el-col>
                <el-col :span="12">
                  <fieldset>
                    <div class="d-flex">
                      <div class="p-2">
                        <h2>취약유형 분석</h2>
                      </div>
                      <div class="p-2">
                        <strong><span class="number mint"></span></strong>
                      </div>
                    </div>
                    <!-- 그리드 -->
                    <stone-data-table
                      :loading="searchLoading"
                      :columns="groupWrongColumns"
                      :data="quizWrongTotalData"
                      :table-props="quizTableProps"
                      :page-size="emptyPageSize"
                      :pagination-props="emptyPaginationProps">
                    </stone-data-table>
                  </fieldset>
                </el-col>
              </el-row>
              <fieldset>
                <h2>선생님 의견</h2>
                <el-input type="textarea" :rows="5" v-model.trim="examInfo.exam_times_comment" placeholder="코멘트를 입력하십시오."></el-input>
                <div class="text-right mt-2">
                  <button class="btn mint" type="primary" v-show="commentVisible" @click="saveComment(2)">저장</button>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
      </el-tab-pane> <!-- 종합성적표 end-->

    </el-tabs>

    <el-dialog title="성적표" width="1230px" :visible.sync="dialogTableVisible" append-to-body>
      <div class="card-body text-right">
        <!-- <el-button type="primary" :loading="pdfLoading" @click="handlePDF"><i class="fa fa-download"></i> 성적표 저장</el-button> -->
        <el-button class="pdf circle" type="primary" :loading="pdfLoading" @click="handlePDF"><i class="fas fa-file-pdf"></i></el-button>
      </div>
      <R010202 ref="printDialog" :is-print="true"></R010202>
    </el-dialog>

    <sendGradeNotification ref="sendGrade" @confirm-click="sendGrade"></sendGradeNotification>

  </div>

</template>

<script>

import common from '@/modules/common'
import grade from '@/modules/grade'
import R010202 from './R010202.vue'
import sendGradeNotification from '@/pages/components/sendGradeNotification.vue'

export default {
  name: 'M060103',
  mixins: [common.mixins, grade],
  components: {R010202, sendGradeNotification},
  data () {
    return {
      dialogTableVisible: false,
      itemCount: 20,
      progressTimer: null,
      activeTabName: 'tab-personal',
      examTotalTimesCount: 4
    }
  },
  methods: {
    // 시험 정보 조회
    loadInfo () {
      // 시험 정보
      common.axios.post('/grade/exam/user', this.param)
        .then(response => {
          const result = response.data
          // console.log('result : ', result)
          Object.keys(this.examInfo).forEach(key => {
            this.examInfo[key] = this.isEmpty(result[key]) ? '' : result[key]
          })
          // 모의고사인 경우에만 스파이더 차트를 보여준다
          if (result.exam_paper_type === 'TEST') {
            // 커리큘럼이 없을 경우에는 스파이더 차트 크기를 늘려준다.
            if (result.curriculum_yn === 'N') {
              this.lineVisible = false
              this.radarChartHeight = 442
            } else {
              this.timesVisible = true
            }
          } else {
            this.radarVisible = false
            if (result.curriculum_yn === 'Y') {
              this.lineChartHeight = 418
              this.timesVisible = false
            } else {
              this.graphVisible = false
              // this.lineVisible = false
            }
          }
          // 개인 성적표
          this.loadExamGrade()
          // 종합 성적표 조회(회차별)
          if (result.curriculum_yn === 'Y') {
            this.loadExamGradeTotalTimes()
          }
        })
    },
    saveComment (type) {
      if (type === 1 && this.examInfo.exam_comment === '') {
        this.$message.warning('코멘트 내용을 확인하십시오.')
        return
      } else if (type === 2 && this.examInfo.exam_times_comment === '') {
        this.$message.warning('코멘트 내용을 확인하십시오.')
        return
      }
      this.examInfo.comment_type = type
      common.axios.put('/grade/comment', this.examInfo)
        .then(response => {
          if (response.data.status === 1) {
            this.$message('코멘트가 등록되었습니다.')
          }
        })
    },
    handleCommand (command) {
      if (command === 'send') {
        // this.sendGrade()
        this.handleSendGradeDialog()
      } else if (command === 'refresh') {
        this.loadInfo(this.examInfo.exam_seq)
      } else if (command === 'download') {
        this.pdfPercentage = 0
        this.dialogTableVisible = true
        this.$nextTick(() => {
          this.$refs.printDialog.loadExamUserComment()
        })
      }
    },
    sendGrade (sendType) {
      common.axios.post('/exam/kakao/grade', {seq: this.examInfo.exam_seq, title: this.examInfo.exam_title, users: [this.examInfo], reject_yn: 'Y', send_type: sendType})
        .then(response => {
          const result = response.data
          if (result.status === 1) {
            this.$message('성적표가 발송되었습니다.')
          } else {
            this.$message.warning(result.message)
          }
        })
    },
    handlePDF () {
      this.pdfLoading = true
      this.$refs.printDialog.handlePDF()
    },
    completedPDF (isSuccess) {
      this.pdfLoading = false
      if (!isSuccess) {
        this.$message.error('PDF 생성에 실패하였습니다.')
      }
    },
    handleLineChartOnClick (index) {
      const exam = this.lineChartData.values[index]
      if (this.param.exam_seq === exam.exam_seq) {
        return
      }
      this.$confirm('<strong>' + exam.title + '</strong> 성적표로 이동하시겠습니까?', '', {dangerouslyUseHTMLString: true})
        .then(() => {
          const newParam = Object.assign(this.param, {exam_seq: exam.exam_seq})
          this.$router.push({name: 'M060103', params: newParam})
        }).catch(() => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/M060103.vue